import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Notify from '../components/Notify';
import Header from './Header';
import SideBarMenu from '../components/Header/SideBarMenu';
import { isEmpty, STATUS_MSG } from '../Services/config/globals';
import { notifySet } from '../Services/Actions/CommonActions';

export default function Admin() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (isEmpty(user)) {
      dispatch(notifySet({
        type: 'error',
        message: STATUS_MSG.sessionExpired
      }));
      navigate('/login');
    } else if (user.view.roleView.id !== 1) {
      dispatch(notifySet({
        type: 'error',
        message: STATUS_MSG.authenticationRequired
      }));
      navigate('/login');
    }
  }, [user]);

  if (!isEmpty(user)) {
    return (
      <div className="app body-con">
        <Header />
        <Notify />
        <div className="wrapper">
          <SideBarMenu />
          <div id="content" className="content-box-con">
            <div className="container-fluid p-0">
              <div className="container mw-100 p-0">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
